<div class="review-panel-section">
    <h2 class="section__name">{{ section.name | htmlDecode }}</h2>
    <!-- Elements Rendering -->
    <div *ngFor="let element of section.elements">
        <ng-container [ngSwitch]="categorizeElement(element)">
            <app-summary-price-field *ngSwitchCase="'priceField'" [element]="getGeneralElement(element)"></app-summary-price-field>
            <app-summary-simple-text *ngSwitchCase="'simpleText'" [element]="element"></app-summary-simple-text>
            <app-summary-address-field *ngSwitchCase="'addressField'" [element]="element"></app-summary-address-field>
            <app-summary-file-field *ngSwitchCase="'fileField'" [element]="element"></app-summary-file-field>
            <app-summary-select-field *ngSwitchCase="'selectField'" [element]="element"></app-summary-select-field>
        </ng-container>
    </div>
</div>